import { instance } from "../axios/axiosConfig";
import {
  CompetitorCreateDataType,
  CompetitorEditDataType,
  FetchCompetitorByIdDataType,
  UsernameCreateDataType,
  UsernameEditDataType,
  ValidateBodyType,
  DeleteUsernameByIdDataType,
} from "../types/brandSocialHandlesTypes.tsx";

const brandSocialHandlesApi = {
  fetchSocialUsernames(id: number) {
    return instance.get(`/api/brand/social-usernames/`, {
      headers: {
        "X-Brand-ID": id,
      },
    });
  },
  createSocialUsernames(data: UsernameCreateDataType) {
    return instance.post(`/api/brand/social-usernames/`, data.body, {
      headers: {
        "X-Brand-ID": data.brandId,
      },
    });
  },
  editSocialUsernamesById(data: UsernameEditDataType) {
    return instance.patch(
      `/api/brand/social-usernames/${data.usernameId}/`,
      data.body,
      {
        headers: {
          "X-Brand-ID": data.brandId,
        },
      },
    );
  },
  deleteSocialUsernamesById(data: DeleteUsernameByIdDataType) {
    return instance.delete(`/api/brand/social-usernames/${data.usernameId}/`, {
      headers: {
        "X-Brand-ID": data.brandId,
      },
    });
  },
  fetchCompetitors(id: number) {
    return instance.get(`/api/brand/competitors/`, {
      headers: {
        "X-Brand-ID": id,
      },
    });
  },
  createCompetitor(data: CompetitorCreateDataType) {
    return instance.post(`/api/brand/competitors/`, data.body, {
      headers: {
        "X-Brand-ID": data.brandId,
      },
    });
  },
  editCompetitorById(data: CompetitorEditDataType) {
    return instance.patch(
      `/api/brand/competitors/${data.competitorId}/`,
      data.body,
      {
        headers: {
          "X-Brand-ID": data.brandId,
        },
      },
    );
  },
  deleteCompetitorById(data: FetchCompetitorByIdDataType) {
    return instance.delete(`/api/brand/competitors/${data.competitorId}/`, {
      headers: {
        "X-Brand-ID": data.brandId,
      },
    });
  },
  fetchCreatorPartnerUsernames(id: number) {
    return instance.get(`/api/brand/creator-partner-usernames/`, {
      headers: {
        "X-Brand-ID": id,
      },
    });
  },
  createCreatorPartnerUsernames(data: UsernameCreateDataType) {
    return instance.post(`/api/brand/creator-partner-usernames/`, data.body, {
      headers: {
        "X-Brand-ID": data.brandId,
      },
    });
  },
  editCreatorPartnerUsernamesById(data: UsernameEditDataType) {
    return instance.patch(
      `/api/brand/creator-partner-usernames/${data.usernameId}/`,
      data.body,
      {
        headers: {
          "X-Brand-ID": data.brandId,
        },
      },
    );
  },
  deleteCreatorPartnerUsernamesById(data: DeleteUsernameByIdDataType) {
    return instance.delete(
      `/api/brand/creator-partner-usernames/${data.usernameId}/`,
      {
        headers: {
          "X-Brand-ID": data.brandId,
        },
      },
    );
  },
  validateSocialHandle(body: ValidateBodyType) {
    return instance.post(`/api/brand/validate-social-handle/`, body);
  },
};

export default brandSocialHandlesApi;
